"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
exports.Container = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme, isVisible = _a.isVisible, noAnimation = _a.noAnimation;
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: fixed;\n      bottom: 0;\n      width: 120rem;\n      padding: 1rem 0 3rem 0;\n      background-color: ", ";\n      transform: translateY(", ");\n      transition: transform ", ";\n    "], ["\n      position: fixed;\n      bottom: 0;\n      width: 120rem;\n      padding: 1rem 0 3rem 0;\n      background-color: ", ";\n      transform: translateY(", ");\n      transition: transform ", ";\n    "])), theme.colors.white, isVisible ? '0% ' : '100%', noAnimation ? '0s' : '0.4s');
});
var templateObject_1, templateObject_2;
